var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('md-button',{staticClass:"md-icon-button md-raised md-primary audio-button",attrs:{"disabled":_vm.isPlay},on:{"click":_vm.onStartPlay}},[_c('md-icon',[_vm._v("play_arrow")])],1)}
var staticRenderFns = []

export { render, staticRenderFns }